import React from 'react';
import { Card, CardContent, Typography, Box, Grid } from '@mui/material';
import DescriptionIcon from '@mui/icons-material/Description';
import FormatListNumberedIcon from '@mui/icons-material/FormatListNumbered';
import ScoreIcon from '@mui/icons-material/Score';
import EventIcon from '@mui/icons-material/Event';
import { Exercise } from '../../types/interfaces';

interface ExerciseDetailsProps {
  exercise: Exercise;
}

const ExerciseDetails: React.FC<ExerciseDetailsProps> = ({ exercise }) => {
  return (
    <Card sx={{ p: 1.5, mb: 2, backgroundColor: '#f9f9f9' }}>
      <CardContent sx={{ p: 2, '&:last-child': { pb: 2 } }}>
        {/* Exercise Type */}
        <Typography variant="h5" gutterBottom sx={{ fontWeight: 'bold', color: '#3f51b5', mb: 2 }}>
          Harjoitus {exercise.order}
        </Typography>

        <Grid container spacing={3}>
          {/* Left Column */}
          <Grid item xs={12} md={6}>
            {/* Exercise Instructions */}
            <Box display="flex" alignItems="flex-start" mb={2}>
              <Box display="flex" alignItems="center" sx={{ minWidth: '100px', mr: 2 }}>
                <DescriptionIcon sx={{ mr: 1, color: '#3f51b5' }} />
                <Typography variant="subtitle1" sx={{ fontWeight: 'bold' }}>Ohjeet:</Typography>
              </Box>
              <Typography variant="body2" sx={{ flex: 1 }}>
                {exercise.instructions}
              </Typography>
            </Box>

            {/* Exercise Additional Info */}
            <Box display="flex" alignItems="flex-start" mb={1}>
              <Box display="flex" alignItems="center" sx={{ minWidth: '100px', mr: 2 }}>
                <DescriptionIcon sx={{ mr: 1, color: '#3f51b5' }} />
                <Typography variant="subtitle1" sx={{ fontWeight: 'bold' }}>Lisätiedot:</Typography>
              </Box>
              <Typography variant="body2" sx={{ flex: 1 }}>
                {exercise.additionalInfo || 'Ei lisätietoja'}
              </Typography>
            </Box>
          </Grid>

          {/* Right Column */}
          <Grid item xs={12} md={6}>
            {/* Exercise Order */}
            <Box display="flex" alignItems="center" mb={1}>
              <Box display="flex" alignItems="center" sx={{ minWidth: '140px', mr: 2 }}>
                <FormatListNumberedIcon sx={{ mr: 1, color: '#3f51b5' }} />
                <Typography variant="subtitle1" sx={{ fontWeight: 'bold' }}>Järjestys:</Typography>
              </Box>
              <Typography variant="body2">
                {exercise.order}
              </Typography>
            </Box>

            {/* Exercise Max Score */}
            <Box display="flex" alignItems="center" mb={1}>
              <Box display="flex" alignItems="center" sx={{ minWidth: '140px', mr: 2 }}>
                <ScoreIcon sx={{ mr: 1, color: '#3f51b5' }} />
                <Typography variant="subtitle1" sx={{ fontWeight: 'bold' }}>Maksimipistemäärä:</Typography>
              </Box>
              <Typography variant="body2">
                {exercise.maxScore}
              </Typography>
            </Box>

            {/* Exercise Creation Date */}
            <Box display="flex" alignItems="center" mb={1}>
              <Box display="flex" alignItems="center" sx={{ minWidth: '140px', mr: 2 }}>
                <EventIcon sx={{ mr: 1, color: '#3f51b5' }} />
                <Typography variant="subtitle1" sx={{ fontWeight: 'bold' }}>Luotu:</Typography>
              </Box>
              <Typography variant="body2">
                {new Date(exercise.createdAt).toLocaleDateString()}
              </Typography>
            </Box>

            {/* Exercise Update Date */}
            <Box display="flex" alignItems="center" mb={1}>
              <Box sx={{ minWidth: '140px', mr: 2 }}>
                <Typography variant="subtitle1" sx={{ fontWeight: 'bold' }}>Päivitetty:</Typography>
              </Box>
              <Typography variant="body2">
                {new Date(exercise.updatedAt).toLocaleDateString()}
              </Typography>
            </Box>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
};

export default ExerciseDetails;
